import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=408862b0&scoped=true"
import script from "./SignUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignUp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=408862b0&prod&lang=less&scoped=true"
import style1 from "./SignUp.vue?vue&type=style&index=1&id=408862b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408862b0",
  null
  
)

export default component.exports